import React from 'react';

import { Caption2 } from 'components/Common';
import { Button } from 'components/ui/button';
import { Input } from 'components/ui/input';
import { AdminManagerInputType } from 'features/signup';
import { useFormContext } from 'react-hook-form';

function AdminManager() {
  const methods = useFormContext();
  const adminManagerInfos = methods.watch('adminManagerInfos') as AdminManagerInputType[];

  const isAdminAddable = adminManagerInfos?.length < 6;

  const showError = methods.formState.submitCount > 0;

  const adminManagerInfosErrors = methods.formState.errors.adminManagerInfos as
    | { adminManagerName?: { message?: string }; adminManagerPhoneNumber?: { message?: string } }[]
    | undefined;

  return (
    <div className="flex w-full gap-x-6">
      <div style={{ width: '150px', minWidth: '150px' }} className="flex flex-col items-start">
        <Caption2>담당자정보</Caption2>
        <Caption2 color="Gray30">*선택</Caption2>
      </div>

      <div className="flex w-full flex-1 flex-col gap-y-3">
        {adminManagerInfos?.map(({ adminManagerName, adminManagerPhoneNumber }, idx) => (
          <div key={idx}>
            <div className="flex w-full items-center gap-x-2">
              <div className="flex flex-1 flex-col">
                <label className="mb-1 ml-1 text-c3 font-semibold">이름</label>
                <Input
                  className={`h-[45px] w-full border ${
                    showError && adminManagerInfosErrors?.[idx] ? 'border-primary' : 'border-gray-20'
                  }`}
                  type="text"
                  placeholder="이름"
                  value={adminManagerName || ''}
                  onChange={(e) => {
                    const arr = [...(methods.getValues('adminManagerInfos') || [])];
                    arr[idx] = { ...arr[idx], adminManagerName: e.target.value };
                    methods.setValue('adminManagerInfos', arr, { shouldValidate: true });
                  }}
                />
              </div>

              <div className="flex flex-1 flex-col">
                <label className="mb-1 ml-1 text-c3 font-semibold">연락처</label>
                <Input
                  className={`h-[45px] w-full border ${
                    showError && adminManagerInfosErrors?.[idx] ? 'border-primary' : 'border-gray-20'
                  }`}
                  type="text"
                  placeholder="연락처(-없이 입력)"
                  value={adminManagerPhoneNumber || ''}
                  onChange={(e) => {
                    const arr = [...(methods.getValues('adminManagerInfos') || [])];
                    arr[idx] = {
                      ...arr[idx],
                      adminManagerPhoneNumber: e.target.value.replace(/[^0-9]/g, ''),
                    };
                    methods.setValue('adminManagerInfos', arr, { shouldValidate: true });
                  }}
                />
              </div>

              <div className="flex h-full items-center">
                <button
                  type="button"
                  onClick={() => {
                    const arr = [...(methods.getValues('adminManagerInfos') || [])];
                    arr.splice(idx, 1);
                    methods.setValue('adminManagerInfos', arr, { shouldValidate: true });
                  }}
                  className="text-c4 text-primary"
                >
                  삭제
                </button>
              </div>
            </div>

            <div className="mt-2 w-full text-c4 font-medium text-red-500">
              {showError && adminManagerInfosErrors?.[idx] && '이름과 연락처를 모두 입력해주세요'}
            </div>
          </div>
        ))}

        {isAdminAddable && (
          <Button
            type="button"
            className="h-[43px] w-full cursor-pointer rounded-[8px] border-none bg-primary text-[13px] text-white"
            onClick={() => {
              const arr = [...(methods.getValues('adminManagerInfos') || [])];
              arr.push({ adminManagerId: null, adminManagerName: '', adminManagerPhoneNumber: '' });
              methods.setValue('adminManagerInfos', arr, { shouldValidate: true });
            }}
          >
            + 담당자 추가
          </Button>
        )}
      </div>
    </div>
  );
}

export default AdminManager;
